import React, { useRef, useEffect } from 'react';

const VideoPlayer = ({ src, width, height, isPlaying, onPlayPause, currentTime, onSeek }) => {
  const videoRef = useRef(null);
  const isRemoteSeekRef = useRef(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || isPlaying === undefined) return;
    if (isPlaying) video.play().catch(() => {});
    else video.pause();
  }, [isPlaying]);

  // Sync seek from remote — only jump if the diff is > 1s to avoid micro-jitter
  useEffect(() => {
    if (currentTime === undefined) return;
    const video = videoRef.current;
    if (!video) return;
    if (Math.abs(video.currentTime - currentTime) > 1) {
      isRemoteSeekRef.current = true;
      video.currentTime = currentTime;
    }
  }, [currentTime]);

  return (
    <foreignObject width={width} height={height} style={{ borderRadius: 8, overflow: 'hidden' }}>
      <video
        xmlns="http://www.w3.org/1999/xhtml"
        ref={videoRef}
        src={src}
        controls
        // Explicit px, not '100%' — Safari doesn't reliably resolve
        // percentage sizing inside a <foreignObject> under a transformed/
        // scaled ancestor (the whiteboard pans/zooms via the SVG's
        // viewBox), so this rendered at natural video size instead of
        // scaled with the canvas.
        style={{ width: `${width}px`, height: `${height}px`, display: 'block', background: '#000', borderRadius: 8 }}
        onPlay={() => onPlayPause?.(true)}
        onPause={() => onPlayPause?.(false)}
        onSeeked={() => {
          if (isRemoteSeekRef.current) { isRemoteSeekRef.current = false; return; }
          onSeek?.(videoRef.current?.currentTime ?? 0);
        }}
      />
    </foreignObject>
  );
};

export default VideoPlayer;
